import React from "react";

export interface UseUncontrolledInput<T> {
  /** Value for controlled state */
  value?: T;
  /** Initial value for uncontrolled state */
  defaultValue?: T;
  /** Controlled state onChange handler */
  onChange?: (value: T, ...context: unknown[]) => void;
}

export const useUncontrolled = <T,>({
  value,
  defaultValue,
  onChange = () => {},
}: UseUncontrolledInput<T> = {}): [
  T,
  (value: T, ...context: unknown[]) => void,
  boolean,
] => {
  const [uncontrolledValue, setUncontrolledValue] = React.useState<T>(
    defaultValue !== undefined ? defaultValue : ("" as T)
  );

  const handleUncontrolledChange = (newValue: T) => {
    setUncontrolledValue(newValue);
    onChange(newValue);
  };

  const isControlled = value !== undefined;

  if (isControlled) {
    return [value as T, onChange, true];
  }

  return [uncontrolledValue as T, handleUncontrolledChange, false];
};
